export const rankingItems = [
  {
    id: 'r1',
    rank: 1,
    title: '长安十二时辰',
    subtitle: '古装悬疑 · 48集全',
    badge: '热度榜TOP1',
    heat: '9.8',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20traditional%20Chinese%20palace%20interior%20with%20intricate%20wooden%20carvings%20and%20silk%20drapes%20in%20warm%20amber%20tones%20gorgeous%20period%20costume%20drama%20scene%20with%20soft%20diffused%20lighting%20cinematic%20composition%20with%20shallow%20depth%20of%20field%20film%20still%20aesthetic%20with%20subtle%20warm%20color%20grading%20and%20rich%20cinematic%20texture%20vertical%20poster%20style&width=600&height=800&seq=ranking-01&orientation=portrait',
    tags: ['古装', '悬疑', '国产剧'],
    desc: '雷佳音、易烊千玺主演，大唐天宝三载上元节前夕，长安城混入可疑人员，死囚张小敬临危受命。',
  },
  {
    id: 'r2',
    rank: 2,
    title: '黑暗荣耀',
    subtitle: '复仇悬疑 · 16集全',
    badge: '口碑炸裂',
    heat: '9.6',
    image: 'https://readdy.ai/api/search-image?query=Moody%20Korean%20drama%20atmosphere%20with%20a%20woman%20in%20elegant%20dark%20attire%20standing%20by%20a%20rain%20streaked%20window%20at%20night%20soft%20blue%20and%20amber%20tonal%20contrast%20cinematic%20portrait%20composition%20with%20dramatic%20shadows%20Korean%20drama%20poster%20aesthetic%20emotional%20depth%20and%20high%20production%20value%20vertical%20format&width=600&height=800&seq=ranking-02&orientation=portrait',
    tags: ['复仇', '悬疑', '韩剧'],
    desc: '宋慧乔主演，文东恩精心策划十余年的复仇计划，向曾经霸凌她的人展开致命反击。',
  },
  {
    id: 'r3',
    rank: 3,
    title: '权力的堡垒',
    subtitle: '政治剧情 · 62集全',
    badge: '经典必看',
    heat: '9.5',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20modern%20city%20skyline%20at%20twilight%20with%20glass%20skyscrapers%20reflecting%20golden%20hour%20light%20sophisticated%20political%20thriller%20atmosphere%20aerial%20perspective%20with%20cinematic%20lens%20flare%20rich%20contrast%20between%20warm%20amber%20windows%20and%20cool%20steel%20architecture%20premium%20television%20production%20quality%20filmic%20color%20grading%20vertical%20poster&width=600&height=800&seq=ranking-03&orientation=portrait',
    tags: ['政治', '剧情', '美剧'],
    desc: '凯文·史派西主演，华盛顿政坛的权力博弈，弗兰克·安德伍德的野心之路。',
  },
  {
    id: 'r4',
    rank: 4,
    title: '隐秘的角落',
    subtitle: '犯罪悬疑 · 12集全',
    badge: '豆瓣高分',
    heat: '9.4',
    image: 'https://readdy.ai/api/search-image?query=Moody%20detective%20noir%20atmosphere%20with%20venetian%20blind%20shadows%20across%20a%20wooden%20desk%20vintage%20lamp%20casting%20warm%20pool%20of%20light%20scattered%20case%20files%20and%20photographs%20strong%20chiaroscuro%20lighting%20rich%20browns%20and%20deep%20amber%20tones%20cinematic%20mystery%20atmosphere%20vertical%20composition&width=600&height=800&seq=ranking-04&orientation=portrait',
    tags: ['犯罪', '悬疑', '国产剧'],
    desc: '秦昊、王景春主演，三个孩子在景区游玩时无意拍摄到一场谋杀，命运就此改变。',
  },
  {
    id: 'r5',
    rank: 5,
    title: '我们的蓝调时光',
    subtitle: '治愈温情 · 20集全',
    badge: '温暖治愈',
    heat: '9.3',
    image: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20seaside%20village%20at%20golden%20hour%20with%20soft%20sunlight%20streaming%20across%20colorful%20fishing%20boats%20and%20charming%20cottages%20Jeju%20Island%20atmosphere%20with%20lived%20in%20warmth%20and%20tranquility%20golden%20hour%20lighting%20with%20soft%20bokeh%20lifestyle%20cinematography%20with%20natural%20color%20palette%20vertical%20poster%20format&width=600&height=800&seq=ranking-05&orientation=portrait',
    tags: ['温情', '治愈', '韩剧'],
    desc: '李秉宪、申敏儿主演，济州岛上平凡人的温暖故事，每一集都是一段动人的人生篇章。',
  },
  {
    id: 'r6',
    rank: 6,
    title: '三体',
    subtitle: '科幻巨制 · 30集全',
    badge: '年度期待',
    heat: '9.2',
    image: 'https://readdy.ai/api/search-image?query=Mystical%20cosmic%20scene%20with%20deep%20space%20nebulae%20and%20golden%20light%20rays%20piercing%20through%20interstellar%20dust%20ethereal%20atmosphere%20with%20floating%20luminescent%20particles%20cinematic%20wide%20composition%20rich%20deep%20blues%20and%20warm%20amber%20highlights%20epic%20science%20fiction%20film%20aesthetic%20with%20painterly%20quality%20vertical%20format&width=600&height=800&seq=ranking-06&orientation=portrait',
    tags: ['科幻', '悬疑', '国产剧'],
    desc: '张鲁一、于和伟主演，纳米科学家汪淼与刑警史强联手揭开外星文明三体人的神秘面纱。',
  },
];

export const carouselItems = [
  {
    id: 'c1',
    title: '国产悬疑剧精选：烧脑推理一次看够',
    subtitle: '近年口碑最好的国产悬疑剧合集，从《隐秘的角落》到《漫长的季节》，每一部都值得反复品味',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20mystery%20thriller%20scene%20with%20a%20detective%20standing%20in%20a%20dimly%20lit%20alleyway%20at%20night%20warm%20street%20lamp%20glow%20contrasting%20with%20deep%20shadows%20rain%20slicked%20pavement%20reflecting%20amber%20light%20film%20noir%20aesthetic%20with%20rich%20atmosphere%20cinematic%20widescreen%20composition%20high%20production%20value&width=800&height=450&seq=carousel-01&orientation=landscape',
    tag: '悬疑剧场',
    count: '24部精选',
  },
  {
    id: 'c2',
    title: '韩剧恋爱图鉴：从初遇到永远的浪漫之旅',
    subtitle: '精选近年口碑韩剧，治愈系、虐心系、甜宠系全收录，总有一部打动你的心',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20Korean%20drama%20scene%20with%20a%20couple%20walking%20under%20cherry%20blossom%20trees%20in%20spring%20soft%20pink%20petals%20falling%20gently%20warm%20golden%20afternoon%20light%20shallow%20depth%20of%20field%20with%20dreamy%20bokeh%20emotional%20and%20tender%20atmosphere%20cinematic%20widescreen%20Korean%20drama%20aesthetic&width=800&height=450&seq=carousel-02&orientation=landscape',
    tag: '韩剧精选',
    count: '36部精选',
  },
  {
    id: 'c3',
    title: '美剧高分神作：艾美奖获奖剧集一网打尽',
    subtitle: '从政治权谋到科幻史诗，从黑色幽默到人性剖析，精选艾美奖及金球奖获奖剧集',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20aerial%20view%20of%20Los%20Angeles%20at%20twilight%20with%20the%20Hollywood%20sign%20in%20the%20distance%20golden%20hour%20light%20bathing%20the%20cityscape%20cinematic%20wide%20shot%20with%20lens%20flare%20rich%20contrast%20between%20warm%20amber%20light%20and%20cool%20urban%20shadows%20premium%20television%20production%20quality&width=800&height=450&seq=carousel-03&orientation=landscape',
    tag: '美剧经典',
    count: '48部精选',
  },
  {
    id: 'c4',
    title: '古装大剧巡礼：服化道巅峰之作全收录',
    subtitle: '从汉唐风华到明清烟雨，精选国产古装剧中的视觉盛宴与叙事佳作',
    image: 'https://readdy.ai/api/search-image?query=Magnificent%20ancient%20Chinese%20imperial%20palace%20courtyard%20at%20sunset%20with%20golden%20light%20streaming%20through%20ornate%20red%20pillars%20and%20carved%20wooden%20eaves%20traditional%20lanterns%20glowing%20warmly%20rich%20crimson%20and%20gold%20color%20palette%20cinematic%20wide%20composition%20with%20epic%20scale%20and%20grandeur&width=800&height=450&seq=carousel-04&orientation=landscape',
    tag: '古装剧场',
    count: '52部精选',
  },
  {
    id: 'c5',
    title: '科幻迷必看：硬核科幻剧集终极片单',
    subtitle: '从时间旅行到外星文明，从人工智能到平行宇宙，最烧脑的科幻剧都在这里',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20science%20fiction%20scene%20with%20a%20massive%20spaceship%20docking%20at%20a%20space%20station%20orbiting%20a%20distant%20planet%20nebulae%20and%20stars%20in%20the%20background%20warm%20golden%20engine%20glow%20contrasting%20with%20deep%20space%20darkness%20cinematic%20widescreen%20epic%20scale%20photorealistic%20render&width=800&height=450&seq=carousel-05&orientation=landscape',
    tag: '科幻世界',
    count: '18部精选',
  },
  {
    id: 'c6',
    title: '治愈系剧场：温暖人心的年度口碑好剧',
    subtitle: '生活不易，来一部温暖的剧治愈自己。精选温情、家庭、成长题材高分剧集',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20modern%20living%20room%20with%20warm%20afternoon%20sunlight%20streaming%20through%20large%20windows%20comfortable%20sofa%20with%20soft%20throws%20and%20pillows%20potted%20plants%20creating%20organic%20shadows%20lived%20in%20warmth%20and%20domestic%20tranquility%20golden%20hour%20lighting%20with%20soft%20bokeh%20cinematic%20lifestyle%20aesthetic&width=800&height=450&seq=carousel-06&orientation=landscape',
    tag: '治愈剧场',
    count: '30部精选',
  },
];

export const featureItems = [
  {
    id: 'f1',
    icon: 'ri-movie-2-line',
    title: '全集一次看完',
    desc: '所有剧集均已完结，无需等待周更，全集打包看到过瘾，追剧不再煎熬。',
  },
  {
    id: 'f2',
    icon: 'ri-4k-line',
    title: '高清画质体验',
    desc: '提供1080P至4K超清画质，支持多线路切换，根据网络环境自动适配最佳清晰度。',
  },
  {
    id: 'f3',
    icon: 'ri-global-line',
    title: '海量剧集覆盖',
    desc: '国产剧、韩剧、美剧、日剧、泰剧全面覆盖，热门新剧第一时间更新上架。',
  },
  {
    id: 'f4',
    icon: 'ri-smartphone-line',
    title: '多端同步追剧',
    desc: '支持电脑、平板、手机多端访问，观影记录云端同步，随时随地继续看。',
  },
  {
    id: 'f5',
    icon: 'ri-shield-check-line',
    title: '纯净观影环境',
    desc: '无弹窗广告干扰，不强制注册，打开即看，给你最干净舒适的追剧体验。',
  },
];

export const cardItems = [
  {
    id: 'cd1',
    title: '庆余年 第二季',
    subtitle: '古装权谋 · 36集全 · 豆瓣8.2',
    image: 'https://readdy.ai/api/search-image?query=Epic%20ancient%20Chinese%20palace%20hall%20with%20a%20young%20scholar%20in%20elegant%20robes%20standing%20before%20the%20throne%20intricate%20dragon%20carvings%20on%20golden%20pillars%20dramatic%20lighting%20from%20lanterns%20casting%20warm%20amber%20glow%20cinematic%20composition%20with%20rich%20crimson%20and%20gold%20tones%20period%20drama%20aesthetic&width=600&height=400&seq=card-01&orientation=landscape',
    desc: '范闲假死归来，京都风云再起，权谋与江湖交织，第二季格局全面升级。',
    tag: '国产剧',
  },
  {
    id: 'cd2',
    title: '眼泪女王',
    subtitle: '爱情喜剧 · 16集全 · 豆瓣8.0',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Korean%20couple%20in%20luxurious%20modern%20penthouse%20with%20floor%20to%20ceiling%20windows%20overlooking%20Seoul%20cityscape%20at%20sunset%20warm%20golden%20light%20filling%20the%20room%20romantic%20yet%20dramatic%20atmosphere%20cinematic%20widescreen%20Korean%20drama%20aesthetic%20with%20high%20production%20value&width=600&height=400&seq=card-02&orientation=landscape',
    desc: '金秀贤、金智媛主演，财阀夫妻的婚姻危机与重新相爱，又哭又笑的神作。',
    tag: '韩剧',
  },
  {
    id: 'cd3',
    title: '繁花',
    subtitle: '年代剧情 · 30集全 · 豆瓣8.7',
    image: 'https://readdy.ai/api/search-image?query=Shanghai%20in%20the%201990s%20with%20neon%20lights%20reflecting%20on%20wet%20street%20at%20night%20vintage%20cars%20and%20old%20shopfronts%20with%20Chinese%20characters%20warm%20amber%20and%20red%20neon%20glow%20nostalgic%20cinematic%20atmosphere%20Wong%20Kar%20wai%20style%20aesthetic%20rich%20textures%20and%20moody%20lighting&width=600&height=400&seq=card-03&orientation=landscape',
    desc: '王家卫首部电视剧，胡歌主演，九十年代上海黄河路的商海沉浮与人生百态。',
    tag: '国产剧',
  },
  {
    id: 'cd4',
    title: '杀人者的购物中心',
    subtitle: '动作惊悚 · 8集全 · 豆瓣7.9',
    image: 'https://readdy.ai/api/search-image?query=Intense%20Korean%20action%20scene%20in%20a%20modern%20warehouse%20filled%20with%20weapons%20and%20tactical%20gear%20dramatic%20overhead%20lighting%20creating%20strong%20shadows%20warm%20amber%20contrast%20with%20cool%20steel%20tones%20cinematic%20action%20movie%20aesthetic%20with%20dynamic%20composition%20high%20adrenaline%20atmosphere&width=600&height=400&seq=card-04&orientation=landscape',
    desc: '李栋旭主演，神秘购物中心背后的杀手世界，动作场面酣畅淋漓，反转不断。',
    tag: '韩剧',
  },
  {
    id: 'cd5',
    title: '最后生还者',
    subtitle: '末世剧情 · 9集全 · 豆瓣9.0',
    image: 'https://readdy.ai/api/search-image?query=Post%20apocalyptic%20landscape%20with%20overgrown%20city%20ruins%20bathed%20in%20golden%20sunset%20light%20a%20man%20and%20young%20girl%20walking%20through%20abandoned%20streets%20nature%20reclaiming%20buildings%20cinematic%20wide%20shot%20with%20emotional%20depth%20warm%20amber%20light%20contrasting%20with%20decay%20HBO%20quality%20aesthetic&width=600&height=400&seq=card-05&orientation=landscape',
    desc: 'HBO年度巨制，佩德罗·帕斯卡主演，末世生存与人性光辉的史诗级改编。',
    tag: '美剧',
  },
  {
    id: 'cd6',
    title: '墨雨云间',
    subtitle: '古装爱情 · 40集全 · 豆瓣7.5',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20ancient%20Chinese%20garden%20with%20a%20woman%20in%20flowing%20silk%20robes%20standing%20by%20a%20lotus%20pond%20cherry%20blossom%20petals%20drifting%20in%20the%20air%20soft%20diffused%20sunlight%20through%20willow%20trees%20romantic%20period%20drama%20atmosphere%20with%20pastel%20warm%20tones%20cinematic%20composition&width=600&height=400&seq=card-06&orientation=landscape',
    desc: '吴谨言、王星越主演，县令之女薛芳菲替身复仇，步步为营的权谋爱情。',
    tag: '国产剧',
  },
  {
    id: 'cd7',
    title: '怪奇物语 第四季',
    subtitle: '科幻恐怖 · 9集全 · 豆瓣9.2',
    image: 'https://readdy.ai/api/search-image?query=Retro%201980s%20American%20small%20town%20at%20dusk%20with%20glowing%20neon%20signs%20and%20vintage%20cars%20mysterious%20red%20lightning%20in%20the%20stormy%20sky%20above%20nostalgic%20cinematic%20atmosphere%20with%20warm%20amber%20street%20lights%20and%20deep%20crimson%20sky%20Stranger%20Things%20aesthetic%20with%20synthwave%20vibes&width=600&height=400&seq=card-07&orientation=landscape',
    desc: '经典回归，霍金斯小镇的终极对决，80年代怀旧与超自然恐怖的完美结合。',
    tag: '美剧',
  },
];

export const faqItems = [
  {
    id: 'faq1',
    q: '8848影院的电视剧资源都是高清的吗？',
    a: '是的，8848影院所有电视剧均提供1080P高清画质，部分热门剧集支持4K超清。我们采用多线路多源分发技术，系统会根据您的网络状况自动选择最优播放线路，确保流畅观影体验。遇到卡顿时，您可以手动切换备用线路。',
  },
  {
    id: 'faq2',
    q: '需要注册账号才能观看吗？',
    a: '不需要。8848影院坚持"打开即看"的理念，无需注册、无需登录，所有剧集全员免费开放。如果您希望跨设备同步观影记录和收藏列表，可以选择自愿注册账号，但这不是观看的前提条件。',
  },
  {
    id: 'faq3',
    q: '新剧更新速度快吗？会有广告吗？',
    a: '我们拥有专业的内容更新团队，国产剧通常在播出后2小时内上线，韩剧、美剧在字幕组完成翻译后第一时间更新。8848影院承诺全站无弹窗广告、无强制跳转，为您提供纯净的追剧环境。',
  },
  {
    id: 'faq4',
    q: '支持哪些设备观看？可以下载离线看吗？',
    a: '8848影院全面适配电脑、平板和手机浏览器，无需安装任何APP即可获得良好体验。通过移动端浏览器访问时，支持将剧集添加到桌面快捷方式。离线下载功能正在开发中，敬请期待后续更新。',
  },
];

export const commentItems = [
  {
    id: 'cm1',
    user: '追剧小达人',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20warm%20toned%20abstract%20geometric%20avatar%20with%20soft%20crimson%20and%20amber%20gradient%20minimalist%20design%20clean%20modern%20aesthetic%20circular%20composition&width=80&height=80&seq=avatar-01&orientation=squarish',
    date: '2026-07-28',
    content: '终于找到一个不用注册就能看剧的网站了！繁花全集一口气刷完，画质真的没话说，推荐给所有剧荒的朋友！',
    rating: 5,
  },
  {
    id: 'cm2',
    user: '深夜看剧人',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20warm%20toned%20abstract%20geometric%20avatar%20with%20soft%20terracotta%20and%20cream%20gradient%20minimalist%20design%20clean%20modern%20aesthetic%20circular%20composition&width=80&height=80&seq=avatar-02&orientation=squarish',
    date: '2026-07-25',
    content: '墨雨云间画质超棒，而且没有广告打扰，体验比主流平台还好。希望继续保持这样的品质！',
    rating: 5,
  },
  {
    id: 'cm3',
    user: '韩剧迷妹',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20warm%20toned%20abstract%20geometric%20avatar%20with%20soft%20rose%20and%20gold%20gradient%20minimalist%20design%20clean%20modern%20aesthetic%20circular%20composition&width=80&height=80&seq=avatar-03&orientation=squarish',
    date: '2026-07-22',
    content: '眼泪女王在这里看的全集，翻译质量很高，没有机翻痕迹。韩剧资源很全，黑暗荣耀也在这里补完了！',
    rating: 5,
  },
  {
    id: 'cm4',
    user: '老剧收藏家',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20warm%20toned%20abstract%20geometric%20avatar%20with%20soft%20bronze%20and%20beige%20gradient%20minimalist%20design%20clean%20modern%20aesthetic%20circular%20composition&width=80&height=80&seq=avatar-04&orientation=squarish',
    date: '2026-07-20',
    content: '没想到连权力的堡垒全集都有，很多平台都下架了。这里的老剧资源真的很齐全，收藏了！',
    rating: 4,
  },
  {
    id: 'cm5',
    user: '悬疑爱好者',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20warm%20toned%20abstract%20geometric%20avatar%20with%20soft%20burgundy%20and%20warm%20white%20gradient%20minimalist%20design%20clean%20modern%20aesthetic%20circular%20composition&width=80&height=80&seq=avatar-05&orientation=squarish',
    date: '2026-07-18',
    content: '隐秘的角落和漫长的季节都在这补完的，国产悬疑剧的巅峰。建议增加分类筛选功能会更方便！',
    rating: 5,
  },
];

export const updateItems = [
  {
    id: 'up1',
    date: '2026-08-01',
    title: '《长安十二时辰》4K修复版正式上线',
    desc: '经典古装悬疑剧4K修复版全48集一次性上线，画质全面提升，重温大唐风华。',
  },
  {
    id: 'up2',
    date: '2026-07-30',
    title: '韩剧专区新增《恶鬼》全集资源',
    desc: '金泰梨主演的悬疑恐怖剧《恶鬼》全12集上线，韩剧专区再添口碑佳作。',
  },
  {
    id: 'up3',
    date: '2026-07-28',
    title: '播放体验升级：智能线路切换功能上线',
    desc: '新增智能线路检测与自动切换，播放卡顿时自动跳转最优线路，追剧更流畅。',
  },
  {
    id: 'up4',
    date: '2026-07-25',
    title: '美剧频道新增《人生切割术》全集',
    desc: 'Apple TV+高分职场科幻悬疑剧全两季上线，豆瓣评分9.0+的必看神作。',
  },
  {
    id: 'up5',
    date: '2026-07-22',
    title: '移动端暗黑模式正式发布',
    desc: '移动端浏览器新增暗黑模式支持，夜间追剧自动切换，保护视力更舒适。',
  },
  {
    id: 'up6',
    date: '2026-07-20',
    title: '国产古装剧专题页面上线',
    desc: '汇集近五年所有高分古装剧，按朝代分类浏览，从秦汉到明清一网打尽。',
  },
  {
    id: 'up7',
    date: '2026-07-18',
    title: '追剧收藏功能全面升级',
    desc: '注册用户可创建多个追剧清单，支持自定义排序，管理你的专属片单。',
  },
  {
    id: 'up8',
    date: '2026-07-15',
    title: '「治愈剧场」主题季正式开启',
    desc: '精选30部温暖治愈系剧集，配合夏日主题界面，给你最舒适的追剧体验。',
  },
];

export const topicItems = [
  { id: 'tp1', name: '国产悬疑剧', count: '3.2万讨论', hot: true },
  { id: 'tp2', name: '韩剧推荐', count: '2.8万讨论', hot: true },
  { id: 'tp3', name: '古装剧天花板', count: '2.6万讨论', hot: true },
  { id: 'tp4', name: '美剧入坑指南', count: '2.1万讨论', hot: false },
  { id: 'tp5', name: '高分神剧', count: '1.9万讨论', hot: false },
  { id: 'tp6', name: '冷门好剧', count: '1.7万讨论', hot: false },
  { id: 'tp7', name: '年代剧经典', count: '1.5万讨论', hot: false },
  { id: 'tp8', name: '科幻剧单', count: '1.3万讨论', hot: false },
  { id: 'tp9', name: '治愈系剧集', count: '1.2万讨论', hot: false },
  { id: 'tp10', name: '爱情喜剧', count: '1.1万讨论', hot: false },
  { id: 'tp11', name: '悬疑烧脑', count: '1.0万讨论', hot: false },
];

export const aboutContent = {
  title: '8848影院 — 你的全集追剧第一站',
  paragraphs: [
    '8848影院创立于2023年，致力于为广大剧迷打造一个纯净、高效的全集追剧平台。我们深知追剧等待更新的煎熬，因此专注于提供已完结的高清电视剧全集资源，让每一位观众都能享受"一次看完全集"的畅快体验。',
    '平台涵盖国产剧、韩剧、美剧、日剧等主流剧种，从经典老剧到最新热播剧，从古装权谋到现代都市，从悬疑烧脑到温情治愈，各类题材应有尽有。目前站内已收录超过5000部电视剧全集资源，且每天都在持续更新扩充。',
    '8848影院坚持"打开即看"的理念，无需注册即可免费观看所有内容，全站无弹窗广告，让你专注于剧情本身。我们的内容团队7×24小时待命，确保新剧第一时间上线，让你永远快人一步。',
  ],
  stats: [
    { label: '收录剧集', value: '5,000+' },
    { label: '内容类型', value: '30+' },
    { label: '日均更新', value: '50+' },
    { label: '用户好评', value: '99.2%' },
  ],
};

export const indexItems = [
  {
    id: 'ix1',
    letter: 'A',
    title: '爱情公寓 全五季',
    desc: '经典国产情景喜剧，十年青春回忆',
    count: '124集全',
    tag: '国产剧',
  },
  {
    id: 'ix2',
    letter: 'B',
    title: '冰与火之歌：权力的游戏',
    desc: '史诗级奇幻巨制，HBO扛鼎之作',
    count: '73集全',
    tag: '美剧',
  },
  {
    id: 'ix3',
    letter: 'C',
    title: '陈情令',
    desc: '肖战、王一博主演，仙侠经典之作',
    count: '50集全',
    tag: '国产剧',
  },
  {
    id: 'ix4',
    letter: 'D',
    title: '德鲁纳酒店',
    desc: 'IU、吕珍九主演，奇幻爱情神作',
    count: '16集全',
    tag: '韩剧',
  },
  {
    id: 'ix5',
    letter: 'G',
    title: '鬼怪',
    desc: '孔刘、金高银主演，韩剧经典中的经典',
    count: '16集全',
    tag: '韩剧',
  },
  {
    id: 'ix6',
    letter: 'L',
    title: '琅琊榜',
    desc: '胡歌主演，国产古装权谋剧巅峰',
    count: '54集全',
    tag: '国产剧',
  },
  {
    id: 'ix7',
    letter: 'M',
    title: '漫长的季节',
    desc: '范伟、秦昊主演，年度口碑神作',
    count: '12集全',
    tag: '国产剧',
  },
  {
    id: 'ix8',
    letter: 'Q',
    title: '请回答1988',
    desc: '双门洞的温暖故事，韩剧评分天花板',
    count: '20集全',
    tag: '韩剧',
  },
  {
    id: 'ix9',
    letter: 'Z',
    title: '甄嬛传',
    desc: '孙俪主演，宫斗剧不可逾越的经典',
    count: '76集全',
    tag: '国产剧',
  },
];

export const contactContent = {
  title: '联系我们',
  desc: '有任何剧集推荐、问题反馈或合作意向，欢迎通过以下方式与我们取得联系。8848影院期待听到你的声音。',
  email: 'contact@8848cinema.com',
  wechat: '8848cinema',
  qq: '8848影迷交流群：888888888',
  workingHours: '在线客服时间：每日 09:00 - 24:00',
};

export const mediaItems = [
  {
    id: 'md1',
    title: '【8848影院】2026年度十大必看国产剧盘点',
    duration: '15:32',
    thumbnail: 'https://readdy.ai/api/search-image?query=Cinematic%20collage%20of%20top%20Chinese%20TV%20dramas%20with%20warm%20golden%20and%20crimson%20gradient%20overlay%20elegant%20typography%20design%20with%20film%20strip%20motif%20professional%20video%20thumbnail%20aesthetic%20with%20rich%20contrast%20and%20dramatic%20lighting%20YouTube%20style%20composition&width=800&height=450&seq=media-01&orientation=landscape',
    views: '12.8万',
  },
  {
    id: 'md2',
    title: '韩剧迷必看：2026上半年韩剧口碑排行榜',
    duration: '12:40',
    thumbnail: 'https://readdy.ai/api/search-image?query=Elegant%20Korean%20drama%20themed%20video%20thumbnail%20with%20soft%20warm%20lighting%20featuring%20aesthetic%20collage%20of%20romantic%20scenes%20with%20Korean%20typography%20elements%20professional%20YouTube%20thumbnail%20style%20with%20rich%20golden%20and%20rose%20tones&width=800&height=450&seq=media-02&orientation=landscape',
    views: '9.6万',
  },
  {
    id: 'md3',
    title: '古装剧服化道大盘点：那些美到窒息的造型',
    duration: '18:20',
    thumbnail: 'https://readdy.ai/api/search-image?query=Stunning%20traditional%20Chinese%20costume%20design%20collage%20with%20intricate%20embroidery%20and%20flowing%20silk%20fabrics%20in%20rich%20crimson%20gold%20and%20jade%20tones%20professional%20video%20thumbnail%20layout%20with%20elegant%20frame%20design%20cinematic%20lighting&width=800&height=450&seq=media-03&orientation=landscape',
    views: '8.3万',
  },
  {
    id: 'md4',
    title: '美剧入门指南：10部零门槛高分美剧推荐',
    duration: '14:55',
    thumbnail: 'https://readdy.ai/api/search-image?query=Dynamic%20American%20TV%20show%20themed%20video%20thumbnail%20with%20iconic%20scenes%20montage%20from%20popular%20series%20warm%20cinematic%20color%20grading%20with%20golden%20and%20amber%20accents%20professional%20YouTube%20style%20composition%20with%20bold%20design%20elements&width=800&height=450&seq=media-04&orientation=landscape',
    views: '7.5万',
  },
  {
    id: 'md5',
    title: '小成本大制作：值得一看的冷门高分剧集',
    duration: '20:10',
    thumbnail: 'https://readdy.ai/api/search-image?query=Artistic%20video%20thumbnail%20design%20with%20independent%20film%20aesthetic%20featuring%20warm%20vintage%20color%20palette%20with%20amber%20and%20terracotta%20tones%20cinematic%20film%20grain%20texture%20elegant%20minimalist%20composition%20for%20hidden%20gem%20TV%20series%20recommendation&width=800&height=450&seq=media-05&orientation=landscape',
    views: '6.2万',
  },
];

export const appContent = {
  title: '随时随地，追剧不停',
  subtitle: '无需下载APP，手机浏览器访问8848影院即可获得完整追剧体验',
  features: [
    '适配所有主流手机浏览器',
    '暗黑模式夜间追剧更舒适',
    '一键添加到手机桌面',
    '与电脑端同步观影记录',
  ],
  image: 'https://readdy.ai/api/search-image?query=Modern%20smartphone%20mockup%20displaying%20a%20cinematic%20TV%20drama%20streaming%20interface%20with%20warm%20crimson%20and%20gold%20UI%20design%20elegant%20dark%20mode%20theme%20floating%20phone%20on%20a%20clean%20warm%20gradient%20background%20product%20presentation%20style%20with%20soft%20lighting%20and%20refined%20aesthetic&width=600&height=500&seq=app-mobile&orientation=portrait',
};

export const footerLinks = {
  categories: [
    { label: '国产剧', href: '#ranking' },
    { label: '韩剧', href: '#cards' },
    { label: '美剧', href: '#carousel' },
    { label: '日剧', href: '#index' },
    { label: '古装剧', href: '#carousel' },
    { label: '悬疑剧', href: '#cards' },
  ],
  quickLinks: [
    { label: '热播榜单', href: '#ranking' },
    { label: '精选专题', href: '#carousel' },
    { label: '热门话题', href: '#topics' },
    { label: '最新动态', href: '#updates' },
    { label: '关于我们', href: '#about' },
    { label: '联系我们', href: '#contact' },
  ],
  partners: [
    { label: '合作伙伴', href: '#footer' },
    { label: '友情链接', href: '#footer' },
  ],
};